import { useIntParam, useNavigationContext } from 'hooks';
import { allowedActionsStore } from 'store';

export const useSpeakingSessionAllowedActions = () => {
  const speakingSessionId = useIntParam('sessionId');
  const { locationId } = useNavigationContext();

  const {
    isLoading,
    isFetching,
    data: allowedActions,
  } = allowedActionsStore.service.useGetAllowedSpeakingSessionActionsQuery(
    { speakingSessionId, locationId },
    { skip: Number.isNaN(speakingSessionId) }
  );

  return {
    canReleaseSession: allowedActions?.canReleaseSession ?? false,
    canRemoveSession: allowedActions?.canRemoveSession ?? false,
    canEditSession: allowedActions?.canEditSession ?? false,
    canAssignRooms: allowedActions?.canAssignRooms ?? false,
    canRemoveRooms: allowedActions?.canRemoveRooms ?? false,
    canManageSpeakingStructuresAndSlots:
      allowedActions?.canManageSpeakingStructuresAndSlots ?? false,
    canUnlinkLrwSessions: allowedActions?.canUnlinkLrwSessions ?? false,
    canLinkLrwSessions: allowedActions?.canLinkLrwSessions ?? false,
    canAssignExaminers: allowedActions?.canAssignExaminers ?? false,
    canPrintExamMaterials: allowedActions?.canPrintExamMaterials ?? false,
    isLoading,
    isFetching,
  };
};
